import {action, computed, observable, makeObservable} from 'mobx';

export abstract class Field {
    @observable title;
    @observable hiddenStatus;
    @observable isChanging;

    /* does this 'moved' vars need to be here ? */
    @observable moved;
    @observable movedDown;
    @observable movedUp;

    @observable parentField;

    fieldNeeded;
    name;
    pos;

    collection;

    type: string;

    constructor(field, parent) {
        makeObservable(this);
        this.type = field.type;
        this.parentField = parent;
        this.hiddenStatus = field.hidden;
        this.fieldNeeded = field.needed;
        this.name = field.name;
        this.isChanging = field.isChanging;
        this.pos = field.pos;
        this.title = field.title ? field.title.replace('&amp;', '&') : '';
    }

    abstract setCollection(parent, field): void;

    get screen() {
        if (this.parentField) {
            return this.parentField.screen;
        } else {
            return this;
        }
    }

    get index() {
        return this.parentCollection.fields.indexOf(this);
    }

    get parentCollection() {
        return this.parentField.collection;
    }

    get doesTitleNeedChecks() {
        return true;
    }

    get isDoubleTitleAllowed() {
        return false;
    }

    get nextField() {
        return this.index + 1 < this.parentCollection.fields.length
            ? this.parentCollection.fields[this.index + 1]
            : null;
    }

    @computed get isSelectable() {
        return !this.isChanging && !this.hidden;
    }

    @computed get isSelected() {
        return this.screen.selected && this.screen.selected.name === this.name;
    }

    @computed get isActive() {
        return this.screen.active && this.screen.active.name === this.name;
    }

    @action
    setTitle(title) {
        this.title = title;
    }

    @action setChanging(value) {
        this.isChanging = value;
    }

    @action
    cancelTitleChange() {
        this.setChanging(false);
    }

    @action
    setHide(value) {
        this.hiddenStatus = value;
    }

    setMoved(value) {
        this.moved = value;
    }

    setMovedDown(value) {
        this.movedDown = value;
    }

    setMovedUp(value) {
        this.movedUp = value;
    }

    @computed get needed() {
        return this.fieldNeeded;
    }

    toggleHide(value) {
        if (value === undefined) {
            this.setHide(!this.hidden);
        } else {
            this.setHide(value);
        }
    }

    @computed get hidden() {
        return this.hiddenStatus;
    }

    get sameLevelField() {
        return this.parentCollection.fields;
    }

    isNewNameDouble(newTitle) {
        if (newTitle !== this.title) {
            for (const field of this.sameLevelField) {
                if (field.title.toLowerCase() === newTitle.toLowerCase()) {
                    return true;
                }
            }
        }
        return false;
    }

    isDouble(field, newTitle) {
        return field.title.toLowerCase() === newTitle.toLowerCase();
    }
}
